export default {
  layout: {
    default: [
      '\' 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'й ц у к е н г ш щ з х ї',
      'ф і в а п р о л д ж є \\ {enter}',
      '{shift} я ч с м и т ь б ю . {shift}',
      '{@} {space}',
    ],
    shift: [
      '₴ ! " № ; % : ? * ( ) _ +',
      'Й Ц У К Е Н Г Ш Щ З Х Ї',
      'Ф І В А П Р О Л Д Ж Є / {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю , {shift}',
      '{@} {space}',
    ],
  },
};
